import { observable } from 'mobx';
import type { Moment } from '@this/lib/moment';
import moment from '@this/lib/moment';

export type CancelChargeElementResponseArgs = {
  id: number;
  content: string;
  start_at: string;
  end_at: string;
};

export type CancelChargeElementArgs = {
  id: number;
  content: string;
  startAt: Moment;
  endAt: Moment;
};

export const convertCancelChargeElementResponseToArgs = (response: CancelChargeElementResponseArgs) => {
  const args: CancelChargeElementArgs = {
    id: response.id,
    content: response.content,
    startAt: moment(response.start_at).startOf('day'),
    endAt: moment(response.end_at).endOf('day')
  };
  return args;
};

export default class CancelChargeElement {
  @observable id: number;
  @observable content: string;

  @observable
  startAt: Moment;

  @observable
  endAt: Moment;

  constructor(args: CancelChargeElementArgs) {
    this.id = args.id;
    this.content = args.content;
    this.startAt = args.startAt;
    this.endAt = args.endAt;
  }

  get type() {
    return 'cancel';
  }

  get startDate() {
    return this.startAt;
  }

  get endDate() {
    return this.endAt;
  }

  get title() {
    return 'キャンセル料';
  }

  get summary() {
    return this.content;
  }

  get name() {
    return this.title;
  }

  get mappingDescription() {
    return this.title;
  }

  detail() {
    return '';
  }
}
